import {AdapterProps, FieldAdapter} from '../field-factory';
import {
  NumberInput as MantineNumberInput,
  NumberInputProps,
} from '@mantine/core';
import {FC, useContext} from 'react';
import {ReadOnlyContext} from '../readonly-context';

export type $NumberInputAdapterProps = AdapterProps<NumberInputProps>;

export const $NumberInputAdapter: FC<FieldAdapter<$NumberInputAdapterProps>> = ({
  inputProps: {onChange, disabled, ...inputProps},
  control,
}) => {
  const {
    field: {onChange: fieldOnChange, ...fieldProps},
    fieldState: {invalid},
  } = control;

  const {readOnly} = useContext(ReadOnlyContext);

  const _onChange: NumberInputProps['onChange'] = (value) => {
    fieldOnChange(value);
    onChange?.(value);
  };

  return (
    <MantineNumberInput
      error={invalid}
      disabled={disabled || readOnly}
      onChange={_onChange}
      {...fieldProps}
      {...inputProps}
    />
  );
};